/* unplugin-vue-components disabled */import script from "./JsonCodePage.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonCodePage.vue?vue&type=script&setup=true&lang=js"

import "./JsonCodePage.vue?vue&type=style&index=0&id=6d1c3a6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1c3a6c"]])

export default __exports__